
import { GraficosProps } from '../../../containers/pages/Dashboard';
import {
  UBICACION_REQUEST,
  UBICACION_SUCCESS,
  UBICACION_FAIL
} from '../../actions/Dashboard/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  ubicacionDashboard: GraficosProps[];
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  ubicacionDashboard: [],
};

// Reducer con tipos definidos
const ubicacionDashboard = (state = initialState, action: any) => {
  switch (action.type) {
    case UBICACION_REQUEST:
      return { ...state, loading: true };
    case UBICACION_SUCCESS:
      return {
        ...state,
        loading: false,
        ubicacionDashboard: action.payload,
      };
    case UBICACION_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};



export default ubicacionDashboard;
